import Autocomplete from "@material-ui/lab/Autocomplete";
import { AutocompleteValidator } from "utils/Validators/CommonValidator";
/* core components */
import React from "react";
import TextField from "@material-ui/core/TextField";
import { Validate } from "utils/Validators/Validate";
import conf from "config/env.conf.js";
//import { UserInfoContext } from "contexts/users";
import getDefaultValue from "utils/DefaultValue";
/* custom components */
import useFetch from "hooks/useFetch";

const ListboxOpttype = props => {
  const [, setError] = React.useState();
  const [valid, setValid] = React.useState();
  const [helperText, setHelperText] = React.useState("");

  const [isLoading, fetchData] = useFetch(
    conf.END_POINT_URL + "/ms/opt/subtypes",
    []
  );

  let content = (
    <TextField disabled label="เลือกประเภท อปท" margin="normal" fullWidth />
  );

  let data = [];

  if (!isLoading && fetchData !== null && fetchData.data !== undefined) {
    data = fetchData.data.map(v => {
      return { id: v.ms_opt_sub_type_id, value: v.opt_name };
    });
  }

  if (data.length > 0) {
    content = (
      <Autocomplete
        id="listboxOpttype"
        defaultValue={getDefaultValue(data, props.defaultValue)}
        value={props.value}
        options={data}
        disabled={props.disabled}
        getOptionLabel={option => option.value}
        getOptionSelected={(option, value) => option.id === value.id}
        onChange={AutocompleteValidator(
          props.onChange,
          props.validators,
          setError,
          setHelperText
        )}
        renderInput={params => {
          return (
            <TextField
              {...params}
              label="เลือกประเภท อปท."
              margin="normal"
              error={valid}
              fullWidth
              helperText={helperText}
              inputProps={{
                ...params.inputProps
              }}
              onChange={Validate(
                params.inputProps.value,
                props.required,
                setValid
              )}
              required={props.required}
            />
          );
        }}
        {...props.customProps}
      />
    );
  }

  return content;
};
export default ListboxOpttype;
